export const DRIVERS_STATE = 'DRIVERS';

export const DRIVERS_FUEL_ASSIGNMENTS_TYPES = {
  scheduled: 'Scheduled',
  completed: 'Completed',
  partiallyCompleted: 'PartialCompleted',
  notCompleted: 'NotCompleted'
} as const;
